import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
    fontSize: 34,
  },
  b: {
    fontWeight: 'bold',
  },
  divider: {
    maxWidth: 600,
    margin: theme.spacing(6, 'auto'),
    backgroundColor: '#7833FF',
  },
  companyValues: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    padding: theme.spacing(0, 10),
  },
  companyValueBox: {
    width: 300,
    paddingTop: theme.spacing(4),

    '& img': {
      marginBottom: theme.spacing(1),
    },
  },
  teamAreaButtons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& hr': {
      margin: theme.spacing(0, 2),
    },
  },
  teamMembers: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
    padding: theme.spacing(0, 19),

    [theme.breakpoints.up('lg')]: {
      justifyContent: 'flex-start',
    },
  },
  teamMemberBox: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
  teamMemberItem: {
    width: 120,
    display: 'inline-block',
    textAlign: 'center',

    '& img': {
      maxWidth: '100%',
      borderRadius: theme.shape.borderRadius,
    },
  },
  teamMemberItemOpaque: {
    opacity: 0.4,
  },
  teamAreaButton: {
    textTransform: 'none',
    borderBottom: '2px solid transparent',
  },
  teamAreaButtonActive: {
    color: theme.palette.common.black,
    borderColor: '#7833FF',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
  },
  button: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(1.5, 3),
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
    textTransform: 'none',
    backgroundColor: '#7833FF',
  },
}));
